/* unplugin-vue-components disabled */import { render } from "./topic-tile.vue?vue&type=template&id=979ebf74&scoped=true"
import script from "./topic-tile.vue?vue&type=script&lang=js"
export * from "./topic-tile.vue?vue&type=script&lang=js"

import "./topic-tile.vue?vue&type=style&index=0&id=979ebf74&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979ebf74"],['__file',"src/pages/pulse/topic-tile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "979ebf74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('979ebf74', __exports__)) {
    api.reload('979ebf74', __exports__)
  }
  
  module.hot.accept("./topic-tile.vue?vue&type=template&id=979ebf74&scoped=true", () => {
    api.rerender('979ebf74', render)
  })

}


export default __exports__